var _switch;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNdeIconFormatsPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XLS"
  }), /*#__PURE__*/React.createElement("g", {
    id: "DOC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "PDF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#D1D2D3",
    strokeWidth: 1.2443,
    strokeMiterlimit: 10,
    points: "40.886,18.151 78.632,18.151  78.632,82.026 27.197,82.026 27.197,32.984  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.42,
    y: 22.097,
    fill: "#EF4137",
    width: 54.13,
    height: 21.776
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#BE202E",
    points: "19.42,43.873 26.585,43.873 26.585,50.981  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M32.889,27.667c0.853,0.728,1.281,1.842,1.281,3.344c0,1.506-0.439,2.605-1.316,3.303 c-0.876,0.697-2.215,1.045-4.016,1.045h-1.619v3.396h-2.718V26.578h4.302C30.672,26.578,32.035,26.942,32.889,27.667z  M30.894,32.458c0.325-0.365,0.488-0.898,0.488-1.603c0-0.702-0.212-1.202-0.637-1.499c-0.423-0.295-1.082-0.443-1.977-0.443 h-1.55v4.094h1.829C29.953,33.007,30.567,32.824,30.894,32.458z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M45.597,28.173c1.162,1.062,1.743,2.539,1.743,4.434c0,1.893-0.566,3.391-1.699,4.494 s-2.86,1.654-5.184,1.654h-4.163V26.578h4.305C42.769,26.578,44.436,27.11,45.597,28.173z M43.603,35.411 c0.668-0.627,1.002-1.539,1.002-2.734c0-1.196-0.334-2.117-1.002-2.762s-1.692-0.967-3.074-0.967h-1.516v7.403h1.724 C41.979,36.352,42.935,36.038,43.603,35.411z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M58.053,26.578v2.387h-5.644v2.632h5.366v2.386h-5.366v4.772h-2.718V26.578H58.053z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 33.005,
    y: 50.825,
    fill: "#D1D2D3",
    width: 17.42,
    height: 14.887
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.403,
    y: 58.269,
    fill: "#D1D2D3",
    width: 17.42,
    height: 1.008
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.403,
    y: 61.69,
    fill: "#D1D2D3",
    width: 17.42,
    height: 1.008
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.403,
    y: 50.896,
    fill: "#D1D2D3",
    width: 17.42,
    height: 1.009
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.403,
    y: 54.318,
    fill: "#D1D2D3",
    width: 17.42,
    height: 1.007
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.403,
    y: 65.112,
    fill: "#D1D2D3",
    width: 17.42,
    height: 1.006
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.005,
    y: 68.533,
    fill: "#D1D2D3",
    width: 17.42,
    height: 1.007
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.403,
    y: 68.533,
    fill: "#D1D2D3",
    width: 17.42,
    height: 1.007
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.005,
    y: 71.952,
    fill: "#D1D2D3",
    width: 17.42,
    height: 1.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.403,
    y: 71.952,
    fill: "#D1D2D3",
    width: 17.42,
    height: 1.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.005,
    y: 75.397,
    fill: "#D1D2D3",
    width: 17.42,
    height: 1.005
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.403,
    y: 75.397,
    fill: "#D1D2D3",
    width: 17.42,
    height: 1.005
  })))), /*#__PURE__*/React.createElement("g", {
    id: "HTML"
  }), /*#__PURE__*/React.createElement("g", {
    id: "CSV"
  }), /*#__PURE__*/React.createElement("g", {
    id: "JSON"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNdeIconFormatsPdf);
export default __webpack_public_path__ + "static/media/NDE_icon_formats_pdf.600061ff.svg";
export { ForwardRef as ReactComponent };